module.exports = __webpack_public_path__ + "img/pic-06.bcbf921e.png";